import { Page } from "@/types/PostNode";
import { ToCamelCase, convertKeysToCamelCase } from "@/utils/shortCode";
import { HeroImage, BaseHeroProps } from "./types";
import Hero from ".";

export type ShortCodeHeroProps = ToCamelCase<BaseHeroProps> & {
  has_breadcrumbs?: "true" | "false";
  slant?: "true" | "false";
  show_slant_stripe?: "true" | "false";
  hero_img_width?: number;
  hero_img_height?: number; //some pages heros define their appearance by depending on a fixed value of for image height
  has_title_class_name?: string | null;
};

export function ShortCodeHero(props: ShortCodeHeroProps) {
  const camelCaseProps = convertKeysToCamelCase(props);
  let imgPropExt: Partial<HeroImage> = { ...props.image };

  if (props.image) {
    if (Number(props.hero_img_width)) {
      imgPropExt.width = Number(props.hero_img_width);
    }
    if (Number(props.hero_img_height)) {
      imgPropExt.height = Number(props.hero_img_height);
    }
  }

  const hasBreadcrumbs = props.has_breadcrumbs
    ? props.has_breadcrumbs === "true"
    : undefined;
  const showSlantStripe = props.show_slant_stripe
    ? props.show_slant_stripe === "true"
    : undefined;
  const slant = props.slant ? props.slant === "true" : undefined;
  const showTitleClassName = props.titleClassName
    ? props.titleClassName
    : undefined;

  return (
    <Hero
      {...camelCaseProps}
      image={imgPropExt.sourceUrl ? (imgPropExt as HeroImage) : props.image}
      hasBreadcrumbs={hasBreadcrumbs}
      showSlantStripe={showSlantStripe}
      slant={slant}
      titleClassName={showTitleClassName}
    >
      {props.children}
    </Hero>
  );
}

ShortCodeHero.getPropsFromContent = (content: string) => {
  // Extract subnav items from content
  const regex = /<a class="subnav-item -mt-1".*?<\/a>/g;
  const matches = content.match(regex);
  if (!matches?.length) return {};
  const subnavItems = matches.map((match: string) => {
    const id = match.match(/id="([^"]+)"/)?.[1];
    const name = match.match(/name="([^"]+)"/)?.[1];
    return { id, name };
  });
  return { subnavItems };
};

ShortCodeHero.getPropsFromMeta = (post: Page, path: string) => {
  return {
    title: post.title,
    path: path,
    image: post.featuredImage?.node,
  };
};
